import { OperationVariables } from '@apollo/client'
import { GetRecipientsWithRemindersGQL } from '../../queries/getRecipientsWithReminders'
import { GetRecipientsWithRemindersQuery } from '../../queries/__generated__/getRecipientsWithReminders'
import { runGraphQLQuery } from '../helpers/runGraphQLQuery'
import { AppContext } from '../types'
import {
  LoadRecipientsWithRemindersRequest,
  LoadRecipientsWithRemindersResponse,
} from '../types/services'

const mapRecipientsWithReminders = (
  data: GetRecipientsWithRemindersQuery,
): LoadRecipientsWithRemindersResponse => {
  const recipientItems = data.me?.recipients?.items ?? []
  const reminders = data.reminders ?? []

  const recipients = recipientItems.flatMap(recipient => {
    const reminder = reminders.find(
      rem =>
        rem.recipientId && rem.recipientId === recipient.id && rem.relationship,
    )
    const relationship = reminder?.relationship

    if (!relationship || !recipient.firstName || !recipient.lastName) {
      return []
    }

    return [
      {
        id: recipient.id,
        firstName: recipient.firstName,
        lastName: recipient.lastName,
        relationship,
      },
    ]
  })

  return { recipients }
}

const loadRecipientsWithReminders = async ({
  client,
}: AppContext): Promise<LoadRecipientsWithRemindersResponse> => {
  return runGraphQLQuery<
    GetRecipientsWithRemindersQuery,
    OperationVariables,
    LoadRecipientsWithRemindersResponse
  >({
    client,
    query: GetRecipientsWithRemindersGQL,
    variables: {},
    extractResult: mapRecipientsWithReminders,
  })
}

export const createRecipientsWithReminders = (
  context: AppContext,
): LoadRecipientsWithRemindersRequest => {
  return async () => {
    return loadRecipientsWithReminders(context)
  }
}
